import { isExternalUrl } from "./cookieConsentUtils";
import { getViewerCopy } from "./viewerLanguage";

export const VIDEO_HOSTS = /youtube\.com|youtu\.be|vimeo\.com|wistia\.(com|net)|dailymotion\.com|loom\.com|vidyard\.com/i;
export const AUDIO_HOSTS = /soundcloud\.com|spotify\.com/i;

const LABELS = {
  video: "Video unavailable",
  audio: "Audio unavailable",
  image: "Image unavailable",
  content: "Content unavailable",
};

const mediaSources = (node) => [
  node.getAttribute("src"),
  node.getAttribute("poster"),
  ...Array.from(node.querySelectorAll("source, track")).map((child) => child.getAttribute("src")),
].filter(Boolean);

const kindFor = (node) => {
  if (node.tagName === "IMG") return "image";
  if (node.tagName === "AUDIO") return "audio";
  if (node.tagName === "VIDEO") return "video";
  const src = node.getAttribute("src") || "";
  if (VIDEO_HOSTS.test(src)) return "video";
  if (AUDIO_HOSTS.test(src)) return "audio";
  return "content";
};

const buildPlaceholder = (doc, node) => {
  const kind = kindFor(node);
  const consent = getViewerCopy()?.consent;
  const width = node.getAttribute("width");
  const height = node.getAttribute("height");
  const placeholder = doc.createElement("span");
  placeholder.className = "kz-embed-blocked";
  placeholder.setAttribute("data-kz-cookie-settings", "true");
  placeholder.setAttribute("role", "button");
  placeholder.setAttribute("tabindex", "0");
  placeholder.setAttribute("title", consent ? consent.hint_content : "Accept all cookies to view this content");
  const sizing = [
    width ? `width:${/^\d+$/.test(width) ? `${width}px` : width}` : "",
    height ? `height:${/^\d+$/.test(height) ? `${height}px` : height}` : "",
  ].filter(Boolean).join(";");
  if (sizing) placeholder.setAttribute("style", sizing);
  const title = doc.createElement("span");
  title.className = "kz-embed-blocked__title";
  title.textContent = consent ? consent[`blocked_${kind}`] : LABELS[kind];
  const action = doc.createElement("span");
  action.className = "kz-embed-blocked__action";
  action.textContent = consent ? consent.settings_button : "Cookie settings";
  placeholder.appendChild(title);
  placeholder.appendChild(action);
  return placeholder;
};

const stripExternalBackgrounds = (style) =>
  style.replace(/url\(\s*(['"]?)([^'")]+)\1\s*\)/gi, (match, quote, url) =>
    isExternalUrl(url) ? "none" : match
  );

export const gateThirdPartyHtml = (html) => {
  if (!html || typeof DOMParser === "undefined") return html;
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
  const root = doc.body.firstElementChild;
  if (!root) return html;

  root.querySelectorAll("iframe, video, audio").forEach((node) => {
    const sources = mediaSources(node);
    if (node.tagName === "IFRAME" || sources.some(isExternalUrl)) {
      node.replaceWith(buildPlaceholder(doc, node));
    }
  });

  root.querySelectorAll("img").forEach((node) => {
    if (isExternalUrl(node.getAttribute("src"))) node.replaceWith(buildPlaceholder(doc, node));
  });

  root.querySelectorAll("[style]").forEach((node) => {
    const style = node.getAttribute("style");
    if (/url\(/i.test(style)) node.setAttribute("style", stripExternalBackgrounds(style));
  });

  return root.innerHTML;
};
